import React, { Component } from 'react';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ChannelActionLink } from 'components/atoms/buttons/ChannelActions';
import ProtectedComponent from 'hoc/ProtectedComponent';
import { ADMINAREA_ACCESS } from 'constants/capabilities';

const ProtectedViewEntityButton = ProtectedComponent({
    requiredCapabilities: [ADMINAREA_ACCESS]
})(props => (<ChannelActionLink className="hidden-print" icon={'icon-entities-stroke'} iconSize={'22px'} text={'View in Admin'} entityUrl={props.entityUrl} target={props.target} />));

class ViewEntity extends Component {
    render() {
        const { meta = null } = this.props;
        const entityId = meta ? meta.id : null;
        const isDisabled = this.props.isDisabled;
        const entityUrl = `/admin/entities/${entityId}`;

        if (!entityId || isDisabled) {
            return null;
        }

        return (<ProtectedViewEntityButton entityUrl={entityUrl} target="_blank" />);
    }
}

ViewEntity.propTypes = {
    isDisabled: PropTypes.string,
    meta: PropTypes.object,
};

const mapStateToProps = state => ({
    meta: state.entities.meta
});

export default connect(mapStateToProps, { push })(ViewEntity);



// WEBPACK FOOTER //
// ./src/containers/buttons/ViewEntity.js